import { Spin } from "antd";

export default function Loading({ isLoading }) {
  return (
    <div className="fixed-center">{isLoading && <Spin size="large" />}</div>
  );
}
